import { ChangeEventHandler, FC } from 'react';
import {
	Accordion,
	NumberInput,
	Checkbox,
	Collapse,
	SimpleGrid,
	Text,
	NumberInputProps,
} from '@mantine/core';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { UUID } from '@/types/types';
import { useContent } from '@/providers/ContentProvider';

const baseSlug = 'creator.';

export const SiphonsPlacement: FC = () => {
	const dispatch = useTypedDispatch();

	const { getContent } = useContent();

	const { product, options, siphons } = useTypedSelector((app) => app.creator);

	const handleCheckboxChange: ChangeEventHandler<HTMLInputElement> = ({
		target,
	}) => {
		dispatch(creatorActions.setIsAutoSiphonsPositioning(target.checked));
	};

	const handlePosXChange =
		(id: UUID): NumberInputProps['onChange'] =>
		(value) => {
			dispatch(creatorActions.setSiphonPosX({ id, posX: Number(value) }));
		};

	return (
		<Accordion.Item value="siphons-placement">
			<Accordion.Control disabled={!product}>
				{getContent(`${baseSlug}sixthOption.name`)}
			</Accordion.Control>
			<Accordion.Panel>
				<Checkbox
					label="Rozmieść automatycznie"
					checked={options.isAutoSiphonsPositioning}
					onChange={handleCheckboxChange}
				/>
				<Collapse expanded={!options.isAutoSiphonsPositioning}>
					<Text mt="md" mb="sm">
						{getContent(`${baseSlug}sixthOption.description`)}
					</Text>
					<SimpleGrid cols={2}>
						{siphons.map((siphon, idx) => (
							<NumberInput
								key={siphon.id}
								label={`Syfon ${idx + 1}`}
								suffix=" mm"
								value={siphon.posX}
								step={1}
								decimalScale={1}
								onChange={handlePosXChange(siphon.id)}
								min={options.minSiphonsXpos}
								max={options.maxSiphonsXpos}
							/>
						))}
					</SimpleGrid>
				</Collapse>
			</Accordion.Panel>
		</Accordion.Item>
	);
};
